module.exports = __webpack_public_path__ + "static/media/ipms.006ff43e.svg";